<template>
    <card title="Cambiar Contraseña" icon="lock">
            <div class="row">
                <div class="col-md-6">
                        <div class="card shadow">
                            <div class="card-body" style="padding: 40px 80px 40px 80px">        
                            <h4>Usuario: {{user.fullName}}</h4>  <br>   
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="fa fa-key"></i>
                                        </span>    
                                    </div>
                                    <input @input="changePassword" placeholder="Contraseña" type="password" :class="'form-control ' + (newPassMessage?'is-invalid':'')" v-model="passData.newPassword" />
                                    <div class="invalid-feedback">{{ newPassMessage }}</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="fa fa-key"></i>
                                        </span>  
                                    </div>
                                    <input @input="changePassword" placeholder="Confirmar Contraseña" type="password" :class="'form-control ' + (confirmPassMessage?'is-invalid':'')"  v-model="passData.confirmPassword" />
                                    <div class="invalid-feedback">{{ confirmPassMessage }}</div>
                                </div>
                            </div>
                            <button @click="save()" class="btn btn-success" style="float: right;" :disabled="BtnSaveDisabled"><i class="fa fas fa-save mr-2"></i>Guardar</button>
                    </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="text-center"> 
                        <img  src="/ventisquero_smallLogo_dark.png" width="80%" alt="Viña Ventisquero">                   
                    </div> 
                </div>
            </div>
    </card>
</template>

<script>
import { Put } from "../../helper/axios.js";
import toastr from "toastr";
export default {
    data() {
        return {
           Put,
           passData: {},
           BtnSaveDisabled: true,
        }
    },
    methods: {
        changePassword() {
            if (this.isValid)
                this.BtnSaveDisabled = false;
            else
                this.BtnSaveDisabled=true
        },
        save(){
            this.$store.commit("setLoading", true);
            this.Put(this.$store.getters.apiUrl +  'v1/changepassword/'+ this.user.id,this.passData,()=>{
                    this.$store.commit("setLoading", false);
                    toastr.success('contraseña cambiada correctamente.');
                    this.$router.push("/");
                })
        }
    },
    computed: {
        user(){
                return this.$store.getters.user
        },
        newPassMessage(){
                let message = ''
                if(!this.passData.newPassword)
                    message = 'Agregue la nueva contraseña'
                return message
        },
        confirmPassMessage(){
            let message = ''
            if(!this.passData.confirmPassword)
                message = 'Confirme la nueva contraseña'
            if(this.passData.newPassword !== this.passData.confirmPassword)
            {
                message='Las contraseñas no coinciden'
            }
            return message
        },
        isValid(){
            return !this.newPassMessage && !this.confirmPassMessage
        }
    }
}
</script>